import { createSelector, createFeatureSelector } from '@ngrx/store';

import { CropAidState, CropAid, SkalTypeEnum } from '../crop-aid.model';

export const selectCropAidState = createFeatureSelector<CropAidState>('crop-aid');

export const selectCropAids = createSelector(selectCropAidState, (state) => state.cropAids || []);

export const selectCropAid = createSelector(
  selectCropAids,
  (cropAids: CropAid[], cropAidId: number) => cropAids.find((cropAid) => cropAid.id === cropAidId),
);

export const selectOrganicCropAids = createSelector(selectCropAids, (cropAids: CropAid[]) =>
  cropAids.filter(
    (cropAid) =>
      cropAid.isFertilizer && cropAid.fertilizer && cropAid.fertilizer.skalType !== SkalTypeEnum.C,
  ),
);
